/* eslint-disable react/prop-types */
/* eslint-disable */
import React, { useState, useEffect } from 'react'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import { makeStyles } from '@material-ui/core/styles'
import {
  Button,
  IconButton,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@material-ui/core'
import { Delete, Add, Restore, Edit as EditIcon } from '@material-ui/icons'
import { MaterialReactTable } from 'material-react-table'
import { useTranslation } from 'react-i18next'
import { getSlideoutInfo, getUser } from '../../../redux/global'
import { successToast, errorToast } from '../../../common/functions'
import ExportCsv from '../../Controls/ExportCsv'
import EditCountrySettingsFields from './EditCountrySettingsFields'
import * as localGdeTransactions from '../../../services/firestore/localGdeTransactions'

const useStyles = makeStyles((theme) => ({
  container: {
    width: '100%',
  },
  fieldSelection: {
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
  },
  actions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
}))

const EdgeCountrySettingsFields = (props) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const [editCountrySettingsFieldsOpen, seteditCountrySettingsFieldsOpen] = useState(false)
  const [qcThreshold, setQcThreshold] = useState(null)
  const [country, setCountry] = useState('')
  const [countryData, setCountryData] = useState([])
  const [editingRow, setEditingRow] = useState(null)
  const [isEditMode, setIsEditMode] = useState(false) 

  useEffect(() => {
    const unsubscribe = localGdeTransactions.getCountrySettingsListener('listener', setCountryData)
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe()
      }
    }
  }, [])



  const columns = [
    {
      accessorKey: 'country',
      header: t('smartCatalogLocal.country'),
      Cell: ({ row }) =>
        <Typography>{row.original.country}</Typography>
    },
    {
      accessorKey: 'qcThreshold',
      header: t('smartCatalogLocal.qcThreshold'),
      Cell: ({ row }) =>
        <Typography>{row.original.confidence}</Typography>
    },
  ]

  return (
    <div className={classes.container}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginBottom: '20px',
        }}
      >
        <Button variant='contained' color='primary' onClick={() => {
          setIsEditMode(false)
          setEditingRow(null)
          setCountry('');
          setQcThreshold(null)
          seteditCountrySettingsFieldsOpen(true)
          }}
          >
          <Add style={{ marginRight: 8 }} />
          {t('dialogs.addNewCountry')}
        </Button>
      </div>
      <MaterialReactTable
        columns={columns}
        data={countryData}
        enableColumnFilters
        enableRowActions
        positionActionsColumn="last"
        renderRowActions={({ row }) => (
          <IconButton
            size="small"
            onClick={() => {
              setEditingRow(row.original)
              setIsEditMode(true)
              setQcThreshold(row.original.confidence)
              setCountry(row.original.country)
              seteditCountrySettingsFieldsOpen(true)
            }}
          >
          <EditIcon />
        </IconButton>
  )}
        renderTopToolbarCustomActions={({ table }) => {
          const isDisabled = !table.getIsSomeRowsSelected()
          const isNoData = countryData?.length === 0
          const isNoPageData = countryData?.length > 4
          return (
            <ExportCsv
              columns={columns}
              isDisabled={isDisabled}
              isNoData={isNoData}
              isNoPageData={isNoPageData}
              table={table}
              hideExportSelectedData={false}
              hideExportPageData={false}
              enableExport={true}
            />
          )
        }}
      />
      <EditCountrySettingsFields
        open={editCountrySettingsFieldsOpen}
        onClose={() => seteditCountrySettingsFieldsOpen(false)}
        confidence={qcThreshold}
        country={country}
        isEditMode={isEditMode}
        editData={editingRow}
        existingData={countryData}
      />

    </div>
  )
}

export default EdgeCountrySettingsFields